import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { login } from '../actions/userActions';

function LoginScreen(props) {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [email, setEmail] = useState("")
    const [password, setPassword] = useState("")

    const userLogin = useSelector((state) => state.userLogin)
    const { loading, userInfo, error } = userLogin

    useEffect(() => {
        //console.log(userInfo)
        if (userInfo === null || userInfo === '' || userInfo === undefined) {
            //console.log("In")
        }else{
            navigate('/')
            //console.log("Out")
        }
    }, [userInfo])

    const submitHandler = (e) => {
        e.preventDefault()
        dispatch(login(email, password))
    }

    return (
        <section className="seLogin-wrapper">
            <div className="main-wrapper login-body">
                <div className="login-wrapper">
                    <div className="container">
                        <img className="img-fluid logo-dark mb-2" src="/assets/img/SE-logo.webp" alt="Logo" />
                        <div className="loginbox">
                            <div className="login-right">
                                <div className="login-right-wrap">
                                    <h1>Login</h1>
                                    <p className="account-subtitle">Access to our dashboard</p>
                                    <form onSubmit={submitHandler}>
                                        <div className="form-group text-field">
                                            <input type="text" className="form-control" required value={email} onChange={e => setEmail(e.target.value)} />
                                            <label className="form-control-label">Email Address</label>
                                        </div>
                                        <div className="form-group text-field">
                                            <input type="Password" className="form-control" required value={password} onChange={e => setPassword(e.target.value)} />
                                            <label className="form-control-label">Password</label>
                                        </div>
                                        <div className="form-group remember-index">
                                            <div className="row">
                                                <div className="col-12 col-md-6 p-0">
                                                    <div className="custom-control">
                                                        <input type="checkbox" id="indexUser" name="indexUser" />
                                                        <span for="indexUser">Remember me</span>
                                                    </div>
                                                </div>
                                                {/* <div className="col-12 col-md-6 text-end">
                                                        <a className="forgot-link" href="javascript:void(0)">Forgot Password?</a>
                                                    </div> */}
                                            </div>
                                        </div>
                                        {
                                            loading ? (
                                                <button className="btn btn-md btn-block login-index-btn mt-4 " type="button"><div className="spinner-border spinner-border-sm"></div> Login</button>
                                            ) : (
                                                <button className="btn btn-md btn-block login-index-btn mt-4 " type="submit">Login</button>
                                            )
                                        }
                                        <div className="text-center dont-have">
                                            <b>{error}</b><br />
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default LoginScreen